import { SET_SELECTED_CURRENCY } from "constants-lib/actionTypes"

export const setSelectedCurrency = (selectedCurrency) => ({
  type: SET_SELECTED_CURRENCY,
  payload: {
    selectedCurrency,
  },
})
